const actions = {
  saveInformationData({ commit }, data) {
    commit('SAVE_INFORMATION_DATA', data);
  },
  clearInformationData({ commit }) {
    commit('CLEAR_INFORMATION_DATA');
  }
}
export default actions
